export const googleAnalyticsId = 'G-S2TH6MFSRM';
